import { css } from 'lit';
         export default css` 
         @charset "UTF-8";
/* ------------------------------------*\
    #BREAKPOINT VARIABLES
\*------------------------------------ */
/* ------------------------------------*\
    #TYPOGRAPHY APPLICATIONS
\*------------------------------------ */
/**
   * Visible focus outline 2px inside the element on a light background
   */
/**
   * Visible focus outline 2px inside the element on a dark background
   */
/**
   * Visible focus outline for elements on a light background
   */
/**
   * Invisible focus outline for elements that need a more visible
   * focus state for high-contrast mode
   */
/**
   * Visually hidden from display
   */
/**
   * style for text ellipsis
   */
/**
   * Popover attribute has default styling which comes from UA stylesheets which will be overridden here.
   */
/* ------------------------------------*\
    #VISIBILITY UTILITIES
\*------------------------------------ */
/* Completely remove from the flow and screen readers. */
.cat-u-is-hidden {
  display: none !important;
  visibility: hidden !important;
}

/* Completely remove from the flow but leave available to screen readers. */
.cat-u-is-vishidden {
  position: absolute !important;
  overflow: hidden;
  width: 1px;
  height: 1px;
  padding: 0;
  border: 0;
  clip: rect(1px, 1px, 1px, 1px);
}

/**
 * Hide element at sm breakpoint 
 */
@media all and (min-width: 23.4375rem) {
  .cat-u-hide-sm {
    display: none !important;
  }
}

/**
 * Hide element at sm-2 breakpoint 
 */
@media all and (min-width: 35rem) {
  .cat-u-hide-sm-2 {
    display: none !important;
  }
}

/**
 * Hide element at md breakpoint 
 */
@media all and (min-width: 48rem) {
  .cat-u-hide-md {
    display: none !important;
  }
}

/**
 * Hide element at lg breakpoint 
 */
@media all and (min-width: 60rem) {
  .cat-u-hide-lg {
    display: none !important;
  }
}

/**
 * Hide element at xl breakpoint 
 */
@media all and (min-width: 75rem) {
  .cat-u-hide-xl {
    display: none !important;
  }
}

/**
 * Show element at sm breakpoint 
 */
@media all and (max-width: 23.4375rem) {
  .cat-u-show-sm {
    display: none !important;
  }
}

/**
 * Show element at sm-2 breakpoint 
 */
@media all and (max-width: 35rem) {
  .cat-u-show-sm-2 {
    display: none !important;
  }
}

/**
 * Show element at md breakpoint 
 */
@media all and (max-width: 48rem) {
  .cat-u-show-md {
    display: none !important;
  }
}

/**
 * Show element at lg breakpoint 
 */
@media all and (max-width: 60rem) {
  .cat-u-show-lg {
    display: none !important;
  }
}

/**
 * Show element at xl breakpoint 
 */
@media all and (max-width: 75rem) {
  .cat-u-show-xl {
    display: none !important;
  }
}

/* ------------------------------------*\
    #RESET
\*------------------------------------ */
/**
 * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/
 */
*,
::slotted(*),
*:before,
*:after {
  box-sizing: border-box;
}

:focus-visible {
  outline-color: var(--cat-theme-color-focus-ring);
}

/* ------------------------------------*\
    #PRIMARY NAV ITEM
\*------------------------------------ */
/**
 * Actual primary nav list item
 */
.cat-c-primary-nav__item {
  border-block-end: var(--cat-border-width-sm) solid var(--cat-theme-color-border-md);
  margin-inline-start: 0;
  --cat-list-item-link-margin-inline-start: 0;
  --cat-list-item-link-width: 100%;
  /**
  * Breadcrumbs item within the last cat-breadcrumbs-item wrapper
  * 1) Zero out the first item's left margin
  */
  /* 1. Below size(3) is reduced because of extra size(3) left margin for list-item */
}
:host(:first-child) .cat-c-primary-nav__item:not(.cat-is-mobile) {
  margin-inline-start: 0;
}
.cat-c-primary-nav__item.cat-c-primary-nav__item--dropdown {
  position: relative;
}
.cat-c-primary-nav__item.cat-c-primary-nav__item--megamenu {
  position: static;
}
.cat-c-primary-nav__item:not(.cat-is-mobile) {
  margin-inline-start: var(--cat-space-medium);
  width: auto;
  border-block-end: none;
}
.cat-c-primary-nav__item.cat-is-mobile {
  --cat-list-item-body-width: calc(100% - calc(var(--size-base-unit) * 3)); /* 1 */
}
.cat-c-primary-nav__item:hover:not(.cat-is-mobile) {
  background: var(--cat-theme-color-background-xstrong-hover);
}

.cat-c-primary-nav__icon-before {
  margin-inline-end: var(--cat-space-x-small); /* 1 */
}

.cat-c-primary-nav__icon-after {
  margin-inline-start: var(--cat-space-x-small);
}

.cat-c-primary-nav__icon {
  pointer-events: none;
}

.cat-c-wrapper {
  display: block;
  width: fit-content;
  position: relative;
  min-width: calc(var(--size-base-unit) * 25);
}

.cat-c-primary-nav__link ::slotted(a) {
  color: var(--cat-theme-color-content-knockout);
  text-decoration: none;
  cursor: pointer;
}
.cat-c-primary-nav__item.cat-is-current:not(.cat-is-mobile) .cat-c-primary-nav__link ::slotted(a) {
  background: transparent;
  color: var(--cat-theme-color-content-knockout-brand);
}

/**
 * Primary navigation link
 * 1) Used to remove any sort of default button styles when a button tag is rendered
 */
.cat-c-primary-nav__link {
  font-family: var(--cat-theme-typography-title-font-family);
  font-weight: var(--cat-theme-typography-title-font-weight);
  font-size: var(--cat-theme-typography-title-font-size);
  line-height: var(--cat-theme-typography-title-line-height);
}
@media all and (width <= calc(48rem - 0.02px)) {
  .cat-c-primary-nav__link {
    font-size: var(--cat-theme-typography-title-mobile-font-size);
    line-height: var(--cat-theme-typography-title-mobile-line-height);
  }
}
.cat-c-primary-nav__link {
  font-size: var(--cat-font-size-20);
  line-height: var(--cat-line-height-28);
  display: flex;
  align-items: center;
  appearance: none; /* 1 */
  background: none; /* 1 */
  border: none; /* 1 */
  position: relative;
  white-space: nowrap;
  width: 100%;
  margin: 0;
  padding: calc(var(--size-base-unit) * 1.75) var(--cat-space-medium);
  color: var(--cat-theme-color-content-knockout);
  text-decoration: none;
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
  cursor: pointer;
}
.cat-c-primary-nav__link:hover {
  background: var(--cat-theme-color-background-xstrong-hover);
}
.cat-is-mobile .cat-c-primary-nav__link {
  white-space: normal;
}
.cat-is-mobile .cat-c-primary-nav__link .cat-c-primary-nav__text {
  text-overflow: ellipsis;
  overflow: hidden;
  text-align: start;
}
.cat-c-primary-nav__item.cat-is-current .cat-c-primary-nav__link {
  color: var(--cat-theme-color-content-knockout-brand);
}
.cat-c-primary-nav__item.cat-is-current .cat-c-primary-nav__link:before {
  content: "";
  display: block;
  position: absolute;
  inset-block-start: 0;
  inset-inline-start: 0;
  height: 100%;
  width: 4px;
  background: var(--cat-theme-color-background-brand);
}
.cat-c-primary-nav__item.cat-is-current:not(.cat-is-mobile) .cat-c-primary-nav__link {
  background: transparent;
  color: var(--cat-theme-color-content-knockout-brand);
}
.cat-c-primary-nav__item.cat-is-current:not(.cat-is-mobile) .cat-c-primary-nav__link:before {
  content: none;
}
.cat-c-primary-nav__item.cat-is-active.cat-is-mobile .cat-c-primary-nav__link {
  margin-block-end: calc(var(--size-base-unit) * 0.125);
}
.cat-c-primary-nav__item:not(.cat-is-mobile) .cat-c-primary-nav__link {
  font-family: var(--cat-theme-typography-label-font-family);
  font-weight: var(--cat-theme-typography-label-font-weight);
  font-size: var(--cat-theme-typography-label-font-size);
  line-height: var(--cat-theme-typography-label-line-height);
  padding: var(--cat-space-large) var(--cat-space-x-small);
}
.cat-c-primary-nav__item:not(.cat-is-mobile) .cat-c-primary-nav__link:focus-visible, .cat-c-primary-nav__item:not(.cat-is-mobile) .cat-c-primary-nav__link:focus {
  outline: 2px solid var(--cat-theme-color-focus-ring);
  outline-offset: var(--cat-theme-inset-focus-ring, -4px);
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
}

.cat-c-primary-nav__item.cat-is-current:not(.cat-is-mobile) .cat-c-primary-nav__bottom-border {
  border-start-start-radius: var(--cat-theme-border-radius);
  border-start-end-radius: var(--cat-theme-border-radius);
  border-end-end-radius: 0;
  border-end-start-radius: 0;
  background: var(--cat-theme-color-border-brand);
  height: calc(var(--size-base-unit) * 0.5);
  margin-block-start: calc(-1 * var(--cat-space-3x-small));
  transition: background var(--cat-anim-fade-quick) var(--cat-anim-ease);
}

/**
 * Icon within primary navigation item
 */
cat-icon,
.cat-icon {
  display: block;
  margin-inline-start: auto;
  transition: transform var(--cat-anim-fade-quick) var(--cat-anim-ease);
  /**
  * Icon within active primary nav item
  * 1) Rotate the icon to show that the dropdown is open
  */
}
.cat-c-primary-nav__item.cat-is-active cat-icon,
.cat-c-primary-nav__item.cat-is-active .cat-icon {
  transform: rotate(-180deg); /* 1 */
}
.cat-c-primary-nav__item:not(.cat-is-mobile) cat-icon,
.cat-c-primary-nav__item:not(.cat-is-mobile) .cat-icon {
  margin-inline-start: var(--cat-space-x-small);
}

/**
 * Primary nav item panel
 * 1) Panel for the dropdown content
 * 1) Hide when not active
 */
.cat-c-primary-nav__item-panel {
  --cat-list-item-link-padding-block-start: var(--cat-space-small);
  --cat-list-item-link-padding-block-end: var(--cat-space-small);
  visibility: hidden; /* 1 */
  display: none;
  height: 0; /* 1 */
  min-width: 12rem;
  background: transparent;
  opacity: 0; /* 1 */
  transition: all 0s var(--cat-anim-ease);
  z-index: -1;
  /**
  * Primary nav item panel within active item
  * 1) Show the primary nav item dropdown
  */
  /**
  * Slotted cat list within item panel
  */
}
.cat-c-primary-nav__item--megamenu:not(.cat-c-primary-nav__item--steppedmegamenu) .cat-c-primary-nav__item-panel {
  inset-inline-start: 0;
  overflow: hidden; /* 1 */
  width: var(--cat-c-primary-nav-item--megamenu__width, 100%);
  max-width: var(--cat-c-primary-nav-item--megamenu__max-width, none);
  min-width: none;
}
.cat-c-primary-nav__item--steppedmegamenu:not(.cat-is-mobile) .cat-c-primary-nav__item-panel {
  width: auto;
  max-width: 100%;
  --cat-dropdown-panel-body-height: 100%;
  --cat-list-item__dropdown-panel-height: 100%;
  --cat-dropdown-panel-height: 100%;
  --cat-list-item__dropdown-panel-inset-block-start: 0;
  --cat-c-dropdown-panel-body-padding: 0;
  --cat-list-item-link-padding-inline-start: var(--cat-space-medium);
  --cat-list-item-link-padding-inline-end: var(--cat-space-medium);
  --cat-dropdown-panel-border-block-start-left-radius: 0;
  --cat-dropdown-panel-border-block-start-right-radius: 0;
  --cat-dropdown-panel-border-block-end-right-radius: 0;
  --cat-dropdown-panel-border-block-end-left-radius: 0;
  --cat-dropdown-panel-border-color: transparent;
  --cat-panel-box-shadow: none;
}
.cat-c-primary-nav__item:not(.cat-is-mobile) .cat-c-primary-nav__item-panel {
  position: absolute;
  inset-block-start: 100%;
  height: auto;
  border: var(--cat-theme-border-width) solid var(--cat-theme-color-border-default);
  border-radius: var(--cat-border-radius-lg);
  box-shadow: var(--cat-theme-box-shadow-md);
}
.cat-c-primary-nav__item.cat-c-primary-nav__item--steppedmegamenu:not(.cat-is-mobile) .cat-c-primary-nav__item-panel {
  border: none;
  border-radius: 0;
  box-shadow: var(--cat-theme-box-shadow-lg);
}
@media all and (min-width: 48rem) {
  .cat-c-primary-nav__item--dropdown-align-left .cat-c-primary-nav__item-panel {
    inset-inline-start: unset;
    inset-inline-end: 0;
  }
}
.cat-c-primary-nav__item--dropdown.cat-is-active .cat-c-primary-nav__item-panel {
  padding-inline: calc(var(--size-base-unit) * 0.25);
  --cat-c-dropdown-panel-body-padding: var(--cat-space-3x-small) calc(var(--size-base-unit) * 0.25);
}
.cat-c-primary-nav__item.cat-is-active .cat-c-primary-nav__item-panel {
  display: block;
  visibility: visible; /* 1 */
  height: auto; /* 1 */
  padding-block: var(--cat-space-x-small);
  opacity: 1; /* 1 */
  z-index: 1;
  transition: opacity var(--cat-anim-fade-quick) var(--cat-anim-ease);
  max-height: var(--cat-primary-nav-item-panel-max-height, auto);
  overflow: var(--cat-primary-nav-item-panel-overflow, visible);
}
.cat-c-primary-nav__item.cat-is-active:not(.cat-is-mobile) .cat-c-primary-nav__item-panel {
  background: var(--cat-theme-color-background-default);
}
.cat-c-primary-nav__item.cat-is-active.cat-is-mobile .cat-c-primary-nav__item-panel {
  padding: 0;
}
.cat-c-primary-nav__item.cat-c-primary-nav__item--megamenu:not(.cat-is-mobile) .cat-c-primary-nav__item-panel {
  padding-block: var(--cat-space-x-small);
}
.cat-c-primary-nav__item.cat-c-primary-nav__item--megamenu.cat-c-primary-nav__item--steppedmegamenu:not(.cat-is-mobile) .cat-c-primary-nav__item-panel {
  padding-block: 0;
}
.cat-c-primary-nav__item-panel ::slotted(cat-list) {
  color: var(--cat-theme-color-content-knockout);
  --cat-list-item-link-hover-background: var(--cat-theme-color-background-xstrong-hover);
}
.cat-c-primary-nav__item:not(.cat-is-mobile) .cat-c-primary-nav__item-panel ::slotted(cat-list) {
  color: var(--cat-theme-color-content-default);
  --cat-list-item-link-hover-background: var(--cat-theme-color-background-default-hover);
}
.cat-c-primary-nav__item.cat-c-primary-nav__item--steppedmegamenu:not(.cat-is-mobile) .cat-c-primary-nav__item-panel ::slotted(cat-list) {
  --cat-list-item-link-static-background: var(--cat-theme-color-background-default);
}
.cat-c-primary-nav__item.cat-c-primary-nav__item--steppedmegamenu.cat-is-mobile .cat-c-primary-nav__item-panel ::slotted(cat-list) {
  --cat-list-item-link-static-background: var(--cat-theme-color-background-xstrong);
}

/**
* Primary nav item panel inner container
* 1) Square off the dropdown ppanels in the more flyout
*/
.cat-c-primary-nav__item-panel-inner {
  /**
  * Primary nav item inner container within megamenu item
  * 1) Cap the content width and center
  */
}
.cat-c-primary-nav__item--megamenu .cat-c-primary-nav__item-panel-inner {
  padding-inline: var(--cat-space-x-small);
}
.cat-c-primary-nav__item--megamenu.cat-c-primary-nav__item--steppedmegamenu .cat-c-primary-nav__item-panel-inner {
  padding-inline: 0;
}

.cat-c-primary-nav__item:not(.cat-c-primary-nav__item--has-slot-before) [part=icon-before], .cat-c-primary-nav__item:not(.cat-c-primary-nav__item--has-slot-after) [part=icon-after] {
  display: none;
}
`;
       